import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FocusService {
  private focusRequestedSource = new Subject<string>();

  focusRequested$ = this.focusRequestedSource.asObservable();

  requestFocus(elementId: string): void {
    this.focusRequestedSource.next(elementId);
  }
}
